import { Injectable } from '../dependency-injection';
import { StorageProvider } from '../types';

@Injectable()
export class SessionStorageService extends StorageProvider {
    constructor() {
        super(window.sessionStorage);
    }
}
